import { snakeCase } from 'lodash-es';

export function dotnetSnakeCase(value: string): string {
	// Dotnet snake case algo is different from lodash snake case
	// It doesn't separate numbers from letters with underscore
	// instead it keeps number attached to preceding letter
	// e.g. help2_pay instead of help_2_pay, b2_bin_pay instead of b_2_bin_pay
	// so we try to mimic this behavior here
	return snakeCase(value)
		.replace(/(\w)_(\d)/gu, '$1$2');
}
